import React from "react";
import {Dialog} from "@mui/material";
import PropTypes from "prop-types";
import {
    ActionButton,
    Boat, ButtonsWrapper,
    CloseIcon,
    DialogContent,
    Header,
    Subtitle, Text,
    Title,
    Wrapper
} from "./styles";
import close from '../../../../assets/images/reservation/close.svg';
import boat from '../../../../assets/images/reservation/failure-boat.svg';
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";

const ReservationFailureDialog = props => {
    const {open, labels, onClose, redirectUrl, onSendRequest} = props;
    const {t} = useTranslation();

    return <Dialog open={open} onClose={onClose} fullScreen maxWidth="lg" PaperProps={{
        style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            boxSizing: 'border-box',
            display: "flex",
            alignItems: 'center',
            justifyContent: 'center',
        },
    }}>
        <Wrapper>
            <a href={redirectUrl} target="_top">
                <CloseIcon src={close}/>
            </a>
            <Header />
            <DialogContent>
                <Title>{t('OOPS')}</Title>
                <Subtitle>{t(labels.Subtitle)}</Subtitle>
                <Text>{t(labels.Text1)}</Text>
                <Text>{t(labels.Text2)}</Text>
                <ButtonsWrapper>
                    <ActionButton onClick={ onClose }>{t(labels.onClose)}</ActionButton>
                    { !!onSendRequest && <ActionButton onClick={onSendRequest}>{t('SEND_BOOKING_REQUEST')}</ActionButton>}
                </ButtonsWrapper>
            </DialogContent>
            <Boat src={boat} />
        </Wrapper>
    </Dialog>
}

ReservationFailureDialog.propTypes = {
    open: PropTypes.bool,
    redirectUrl: PropTypes.string,
    onClose: PropTypes.func,
    onSendRequest: PropTypes.func,
}

export default ReservationFailureDialog;
